import React, {Component} from 'react';
import {connect} from 'react-redux';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import '../components/stylefeedback.css';


import {
    cancelAction as cancelActionRedux,
    confirmActionRequested,
    proceedAction as proceedActionRedux,
} from '../services/confirmAction/action';
import {addNotification} from "../services/notification/action";
import Translate from "./Translate";
import ConfirmModalFeedback from "./ConfirmModalFeedback";
import {endConversationRequested} from "../services/chat/action";
import BlueButton from "../components-new/buttons/BlueButton";
import SilverButton from "../components-new/buttons/SilverButton";
import config from "../config";
import ConversationDetails from "./ConversationDetails";

const style = {
    overlay: {
        backgroundColor: config.modalBackgroundColor,
        zIndex: '2000',
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        borderRadius: '20px',
        transform: 'translate(-50%, -50%)',
        padding: '40px',
        border: 'none',
        minWidth: '396px',
        maxWidth: '70vh',
        maxHeight: '98vh',
    },
    title: {
        color: 'black',
        marginBottom: '20px',
        textAlign: 'center',
    },
    conversationInfo: {
        backgroundColor: '#f7f9fc',
        padding: '20px',
        borderRadius: '10px',
        marginBottom: '20px',
        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
        fontSize: '13px'
    },
    infoRow: {
        display: 'flex',
        gap: '10px',
        marginBottom: '10px',
    },
    _infoRow: {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '10px',
    },
    label: {
        fontWeight: 'bold',
        color: 'rgb(4, 62, 92)',
        marginBottom: '5px',
    },
    value: {
        color: '#5a5a5a',
        wordWrap: 'break-word',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap',
    },
    buttonsWrapper: {
        display: 'flex',
        gap: '13px',
        marginTop: '15px',
    },
    blockBackground: {
        borderRadius: '50%',
        backgroundColor: 'red',
        width: '30px',
        height: '30px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }
};

Modal.setAppElement('#root');

class ConfirmModalHistory extends Component {

    closeModal = () => {
        const {cancelAction} = this.props;
        cancelAction();
    };

    blockUserClick = () => {
        const {confirmAction, endConversation, conversation, user, company} = this.props;
        conversation.id = conversation.conversationId
        confirmAction({
                content: <ConfirmModalFeedback tariff={company.tariff} isBlockUser={true} user={user}
                                               conversation={conversation}
                                               endConversation={endConversation}/>
            }
        );
    };

    render() {
        const {isOpen, conversation, showConversationHistory, cancelAction} = this.props;

        return (
            <Modal closeTimeoutMS={config.closeTimeoutMS} isOpen={isOpen} style={style}
                   onRequestClose={this.closeModal}>
                <h2 style={style.title}><Translate text={'conversationDetails'}/></h2>

                <ConversationDetails conversationDetails={conversation} withBlockAction={true}
                                     cancelAction={cancelAction} blockUserClick={this.blockUserClick}/>

                <div style={style.buttonsWrapper}>
                    <SilverButton width={'100px'} onClick={this.closeModal} children={<Translate text={'close'}/>}/>
                    <BlueButton type={'button'}
                                width={'180%'}
                                children={<Translate text="chatHistory"/>}
                                onClick={() => {
                                    cancelAction()
                                    showConversationHistory(conversation)
                                }}/>
                </div>
            </Modal>
        );
    }
}

ConfirmModalHistory.propTypes = {
    proceedAction: PropTypes.func.isRequired,
    cancelAction: PropTypes.func.isRequired,
    addNotification: PropTypes.func.isRequired,
    endConversation: PropTypes.func.isRequired,
    conversation: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    isOpen: state.confirmAction.isModalOpen,
    user: state.user,
});

const mapDispatchToProps = dispatch => ({
    addNotification: () => {
        dispatch(addNotification());
    },
    proceedAction: () => {
        dispatch(proceedActionRedux());
    },
    cancelAction: () => {
        dispatch(cancelActionRedux());
    },
    endConversation: () => {
        dispatch(endConversationRequested());
    },
    confirmAction: (obj) => (dispatch(confirmActionRequested(obj.func, obj.args, obj.onCancel, obj.onCancelArgs, obj.content))),
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmModalHistory);



// WEBPACK FOOTER //
// ./src/components/ConfirmModalHistory.jsx